module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "p3"
  }), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('i', [_vm._v("You can rot here without feeling it.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_vm._v("—John Rechy, on Los Angeles")]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('i', [_vm._v("I live here in Kill City where the debris meets the sea")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('i', [_vm._v("It’s a playground for the rich but it’s a loaded gun to me … ")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_vm._v("—Iggy Pop, on Los Angeles")]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('b')])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-23b97ae2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section5.vue
// module id = 78
// module chunks = 0